import MachineForm from "@/components/forms/MachineForm";

export default function EditMachinePage() {
  return <MachineForm edit={true} />;
}
